var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useRef, useEffect, useMemo } from 'react';
import Loading from '../Loading';
import { useDispatch, useSelector } from 'react-redux';
import LivenessIntro from '../StepLivenessLocal/LivenessIntro';
import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';
import { Loader, ThemeProvider } from '@aws-amplify/ui-react';
import { getLivenessDictionary } from './dictionary';
import QrCodeRedirect from '../QrCodeRedirect';
import { RiLock2Fill } from "react-icons/ri";
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { SpanText } from './styles';
import parse from 'html-react-parser';
import Service from '../../services/Service';
import * as FormActions from '../../store/form/actions';
import { useTranslation } from '../../i18n';
require('./aws-liveness-styles.css');
;
var StepLivenessAWS = function (_a) {
    var _b;
    var step = _a.step, loading = _a.loading, onPressConfirm = _a.onPressConfirm;
    var location = useLocation();
    var dispatch = useDispatch();
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var livenessDictionary = useMemo(function () { return getLivenessDictionary(t); }, [i18n.language]);
    var detectorContainerRef = useRef(null);
    var redirect = location.state.redirect;
    var theme = useSelector(function (state) { return state.theme; }).theme;
    var form = useSelector(function (state) { return state.form; }).form;
    var showPolicy = form.steps[step].fields.find(function (field) { return field.field === "checkbox_privacy_policy"; });
    var _d = useState(true), isShowingLivenessInfo = _d[0], setIsShowingLivenessInfo = _d[1];
    var _e = useState(null), createLivenessApiData = _e[0], setCreateLivenessApiData = _e[1];
    var _f = useState(false), isPolicyCheckboxChecked = _f[0], setIsPolicyCheckboxChecked = _f[1];
    var _g = useState((_b = form.steps[step].showQrCodeRedirect) !== null && _b !== void 0 ? _b : false), showQrCodeRedirect = _g[0], setShowQrCodeRedirect = _g[1];
    var _h = useState(false), isCreatingLivenessSession = _h[0], setIsCreatingLivenessSession = _h[1];
    var _j = useState(false), isCheckingLivenessResult = _j[0], setIsCheckingLivenessResult = _j[1];
    var _k = useState(false), isRetrying = _k[0], setIsRetrying = _k[1];
    var stopLivenessCamera = function () {
        var _a;
        var videoEl = (_a = detectorContainerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('video');
        if (videoEl && videoEl.srcObject) {
            var stream = videoEl.srcObject;
            stream.getTracks().forEach(function (track) {
                track.stop();
            });
            videoEl.srcObject = null;
            videoEl.src = '';
            videoEl.pause();
            videoEl.load();
            setTimeout(function () {
                if (videoEl.parentNode) {
                    videoEl.remove();
                }
            }, 100);
        }
    };
    var updateLivenessSessionField = function (sessionId) {
        var updatedForm = __assign(__assign({}, form), { steps: form.steps.map(function (formStep, formStepIndex) {
                if (formStepIndex !== step) {
                    return formStep;
                }
                return __assign(__assign({}, formStep), { fields: formStep.fields.map(function (field) {
                        if (field.field !== 'session_id_liveness_3d_aws') {
                            return field;
                        }
                        return __assign(__assign({}, field), { value: sessionId });
                    }) });
            }) });
        dispatch(FormActions.setForm(updatedForm));
    };
    var createFreshLivenessSession = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, sessionId, sessionField, livenessSessionId, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsCreatingLivenessSession(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, Service.createFaceLivenessSession()];
                case 2:
                    data = _a.sent();
                    sessionId = data === null || data === void 0 ? void 0 : data.sessionId;
                    if (sessionId) {
                        updateLivenessSessionField(sessionId);
                    }
                    sessionField = form.steps[step].fields.find(function (field) { return field.field === 'session_id_liveness_3d_aws'; });
                    livenessSessionId = sessionId || (sessionField === null || sessionField === void 0 ? void 0 : sessionField.value);
                    if (livenessSessionId) {
                        setCreateLivenessApiData(livenessSessionId);
                        return [2 /*return*/, livenessSessionId];
                    }
                    toast.error(t('liveness.sessionError'));
                    console.error('session_id_liveness_3d_aws not found');
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    toast.error(t('liveness.startError'));
                    console.error('Error creating liveness session', error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setIsCreatingLivenessSession(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleOkClickBeforeLivenessAWS = function () { return __awaiter(void 0, void 0, void 0, function () {
        var sessionId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsRetrying(false);
                    return [4 /*yield*/, createFreshLivenessSession()];
                case 1:
                    sessionId = _a.sent();
                    if (sessionId) {
                        setIsShowingLivenessInfo(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var resetLivenessAttempt = function (message) {
        stopLivenessCamera();
        updateLivenessSessionField(undefined);
        setCreateLivenessApiData(null);
        setIsRetrying(true);
        setIsShowingLivenessInfo(true);
        if (message) {
            toast.error(message);
        }
    };
    useEffect(function () {
        if (!isShowingLivenessInfo && !createLivenessApiData && !isCreatingLivenessSession && !isRetrying) {
            createFreshLivenessSession();
        }
    }, [isShowingLivenessInfo, createLivenessApiData, isCreatingLivenessSession, isRetrying]);
    var renderLivenessInfoAWS = function () {
        var _a;
        return (React.createElement(LivenessIntro, { step: step, onStart: handleOkClickBeforeLivenessAWS, mock: false, debugArea: null, startDisabled: isCreatingLivenessSession || (!!showPolicy && !isPolicyCheckboxChecked), startLabel: isCreatingLivenessSession ? t('livenessAws.starting') : undefined, additionalContent: showPolicy ? (React.createElement("div", { className: "flex items-start space-x-2 mt-0" },
                React.createElement("input", { type: "checkbox", checked: isPolicyCheckboxChecked, style: { color: theme.primaryColor }, onChange: function (event) { return setIsPolicyCheckboxChecked(event.target.checked); }, className: "h-4 w-4 rounded border-gray-300 focus:ring-blue-500" }),
                React.createElement("div", { className: "text-sm text-gray-700" }, parse((_a = showPolicy.value) !== null && _a !== void 0 ? _a : '')))) : null }));
    };
    var handleAnalysisComplete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!createLivenessApiData) {
                        resetLivenessAttempt(t('livenessAws.couldNotComplete'));
                        return [2 /*return*/];
                    }
                    setIsCheckingLivenessResult(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, 6, 7]);
                    return [4 /*yield*/, Service.getFaceLivenessSessionResult(createLivenessApiData)];
                case 2:
                    result = _a.sent();
                    if (!((result === null || result === void 0 ? void 0 : result.confidence) && result.confidence > 75 && result.imageQualityApproved !== false)) return [3 /*break*/, 4];
                    stopLivenessCamera();
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 3000); })];
                case 3:
                    _a.sent();
                    onPressConfirm();
                    return [2 /*return*/];
                case 4:
                    if ((result === null || result === void 0 ? void 0 : result.confidence) && result.confidence > 75 && result.imageQualityApproved === false) {
                        resetLivenessAttempt(t('livenessAws.lowQualitySelfie'));
                        return [2 /*return*/];
                    }
                    resetLivenessAttempt(t('livenessAws.notValidated'));
                    return [3 /*break*/, 7];
                case 5:
                    error_2 = _a.sent();
                    console.error('Error checking liveness result', error_2);
                    resetLivenessAttempt(t('livenessAws.couldNotValidate'));
                    return [3 /*break*/, 7];
                case 6:
                    setIsCheckingLivenessResult(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleAnalysisError = function (error) {
        console.error("ERROR LIVENESS", error);
        resetLivenessAttempt(t('livenessAws.couldNotComplete'));
    };
    var themeAWS = {
        name: 'custom-theme',
        tokens: {
            fonts: {
                default: {
                    variable: { value: theme.fontFamily },
                    static: { value: theme.fontFamily },
                },
            },
            components: {
                card: {
                    backgroundColor: { value: theme.backgroundColor },
                    outlined: {
                        borderColor: { value: theme.primaryColor },
                    },
                },
                heading: {
                    color: { value: theme.primaryColor },
                },
                text: {
                    color: { value: theme.primaryColor },
                },
            },
        },
    };
    if (step < 0) {
        return React.createElement(Loading, null);
    }
    ;
    if (showQrCodeRedirect && !redirect) {
        return (React.createElement(QrCodeRedirect, { step: step, nextStepName: t('livenessAws.stepName'), setShow: setShowQrCodeRedirect }));
    }
    if (isShowingLivenessInfo) {
        return renderLivenessInfoAWS();
    }
    return (React.createElement("div", { style: { maxHeight: '600px', backgroundColor: theme.backgroundColor } },
        React.createElement(ThemeProvider, { theme: themeAWS }, (loading || isCheckingLivenessResult || !createLivenessApiData) ? (React.createElement("div", { className: "relative flex flex-col items-center w-full h-screen" },
            React.createElement("div", { className: "absolute top-16 left-1/2 -translate-x-1/2 w-full" },
                React.createElement("div", { className: "inline-flex items-center gap-2 border border-gray-200 text-xs bg-gray-50 px-4 py-2 shadow-sm rounded-sm" },
                    React.createElement(RiLock2Fill, { className: "text-gray-500 text-base flex-shrink-0" }),
                    React.createElement(SpanText, { style: theme.backgroundColor === "#000000" ? { color: "#000000" } : {} }, t('common.secureEnvironment')))),
            React.createElement("div", { className: "flex flex-col items-center justify-center flex-1" },
                React.createElement(Loader, { className: "h-20", style: { backgroundColor: theme.backgroundColor } }),
                React.createElement("p", { className: "mt-4", style: { color: theme.primaryTextColor } }, t('livenessAws.analyzing'))))) : (React.createElement("div", { ref: detectorContainerRef },
            React.createElement(FaceLivenessDetector, { sessionId: createLivenessApiData, region: "us-east-1", onAnalysisComplete: handleAnalysisComplete, onError: handleAnalysisError, disableStartScreen: true, displayText: livenessDictionary }))))));
};
export default StepLivenessAWS;
